import http from "services/http";

const PRE_ENDPOINT = "/api/method/freshdi.api.web.v3";

export const apiSendOtpCode = (data: any) =>
  http.post(`${PRE_ENDPOINT}.auth.send_otp_email`, data);

export const apiVerifyOtpCode = (otp_key: string, email: string) =>
  http.post(`${PRE_ENDPOINT}.auth.verify_email`, { otp_key, email });

export const apiCheckEmailExits = (email: string) =>
  http.get(`${PRE_ENDPOINT}.auth.check_email_exits`, { params: { email } });

export const apiRegisterWithGg = (data: any) =>
  http.post(`${PRE_ENDPOINT}.auth.login_via_google`, data);

export const apiGetActiveAccountInfo = (data: {
  key?: string | null;
  rfq_id?: string | null;
  quotation_id?: string | null;
  message_id?: string | null;
  inquiry_id?: string | null;
  product_id?: string | null;
}) =>
  http.get(`${PRE_ENDPOINT}.auth.get_activate_account_info`, { params: data });
